import { Component, OnInit } from '@angular/core';
import { AlSession, AlLocation } from '@al/core';
import { AlNavigationService } from '@al/ng-navigation-components';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

    /**
     * Public variables
     */
    public view: any = {};

    constructor( public navigation:AlNavigationService ) {
    }

    ngOnInit() {
        this.view['userName'] = AlSession.getUserName();
        this.setUpUrls();
    }

    setUpUrls () {
        this.view['urlCreateEnvironment'] = this.navigation.resolveURL( { locTypeId: AlLocation.ConfigurationUI, path: '/#/deployments/:accountId' } );
        this.view['urlInstallAppliancesAndAgents'] = "https://docs.alertlogic.com/install/cloud/amazon-web-services-threat-manager-landing.htm";
    }

    openTab(TabName:string){
        window.open( this.view[TabName], '_blank');
    }
}
